import React, { useState, memo } from "react";
import { Marker, InfoWindow } from "react-google-maps";

const CustomMarker = ({ position, icon, onClick, empreendimento }) => {
    const [showInfoWindow, setShowInfoWindow] = useState(false);

    const handleMouseOver = () => setShowInfoWindow(true);
    const handleMouseOut = () => setShowInfoWindow(false);

    const { nome, endereco, numero, bairro } = empreendimento || {};

    return (
        <Marker
            position={position}
            icon={icon}
            onClick={onClick}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        >
            {showInfoWindow && (
                <InfoWindow>
                    <div>
                        <h5>{nome}</h5>
                        <small>
                            <strong>Endereço: </strong>{endereco}{" "}{numero}
                            <br />
                            <strong>Bairro: </strong>
                            {bairro}
                        </small>
                    </div>
                </InfoWindow>
            )}
        </Marker>
    );
};

export default memo(CustomMarker);